import * as Yup from 'yup';

import { TreatmentPlanResourceVersion } from '../constants/general';

export const MedicalHistorySchema = Yup.object().shape({
  medical_history_version: Yup.string().trim().required(),
  allergies: Yup.string().trim().required(),
  special_diets: Yup.string().trim().required(),
  state_autism_diagnosis_made: Yup.string().trim().required(),
  city_autism_diagnosis_made: Yup.string().trim().required().min(2),
  year_autism_diagnosis_made: Yup.string().trim().required(),
  provider_name: Yup.string().trim().required().min(2),
  autism_severity_level: Yup.string().trim().required(),
  trauma_history: Yup.string().trim().required().min(4),
  pregnancy_delivery_history: Yup.string().when('medical_history_version', {
    is: (version: string) => version === TreatmentPlanResourceVersion.V2,
    then: () => Yup.string().trim().required().min(2),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  hearing_vision_screening: Yup.string().when('medical_history_version', {
    is: (version: string) => version === TreatmentPlanResourceVersion.V2,
    then: () => Yup.string().trim().required().min(2),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  early_childhood_development: Yup.string().when('medical_history_version', {
    is: (version: string) => version === TreatmentPlanResourceVersion.V2,
    then: () => Yup.string().trim().required().min(2),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  early_childhood_intervention: Yup.string().when('medical_history_version', {
    is: (version: string) => version === TreatmentPlanResourceVersion.V2,
    then: () => Yup.string().trim().required().min(2),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  surgical_hospitalization_history: Yup.string().when('medical_history_version', {
    is: (version: string) => version === TreatmentPlanResourceVersion.V2,
    then: () => Yup.string().trim().required().min(2),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
});

export const MedicalHistoryRowSchema = Yup.object().shape({
  diagnosis_name: Yup.string().trim().required(),
  provider_name: Yup.string().trim().required().min(2),
  city_diagnosis_made: Yup.string().trim().required().min(2),
  state_diagnosis_made: Yup.string().trim().required(),
  year_diagnosis_made: Yup.string().trim().required(),
});

export const ReferralHistorySchema = Yup.object().shape({
  id: Yup.number().optional(),
  referring_provider_name: Yup.string().trim().required().min(2),
  reason_for_referral: Yup.string().trim().required().min(60),
  date_of_diagnosis: Yup.string().trim().required().min(5),
  assessment_tools: Yup.array().when('id', {
    is: (id: number | undefined) => id !== undefined,
    then: () =>
      Yup.array()
        .of(
          Yup.object().shape({
            tool_name: Yup.string().trim().min(2),
          }),
        )
        .min(1),
  }),
});

export const ToolRowSchema = Yup.object().shape({
  tool_name: Yup.string().trim().min(2),
});

export const initialMedicalHistory = {
  allergies: '',
  special_diets: '',
  state_autism_diagnosis_made: '',
  city_autism_diagnosis_made: '',
  year_autism_diagnosis_made: '',
  provider_name: '',
  autism_severity_level: '',
  trauma_history: '',
  pregnancy_delivery_history: '',
  hearing_vision_screening: '',
  early_childhood_development: '',
  early_childhood_intervention: '',
  surgical_hospitalization_history: '',
};

export const initialReferralHistory = {
  referring_provider_name: '',
  reason_for_referral: '',
  assessment_tools: [],
  date_of_diagnosis: '',
};
